import { useState, useEffect } from "react";
import { firestore } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const AnnouncementBar = () => {
  const [open, setOpen] = useState(true);
  const [announcementText, setAnnouncementText] = useState('Free Colombo delivery over Rs. 10,000 - 6-month electronics warranty - Crafted in Sri Lanka');

  useEffect(() => {
    const loadAnnouncementText = async () => {
      try {
        // Check cache first (valid for 1 hour)
        const cached = localStorage.getItem('announcementCache');
        if (cached) {
          const { text, timestamp } = JSON.parse(cached);
          const oneHour = 60 * 60 * 1000;
          if (Date.now() - timestamp < oneHour) {
            setAnnouncementText(text);
            return;
          }
        }

        // Fetch from Firestore
        const docRef = doc(firestore, 'WebInfo', 'settings');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists() && docSnap.data().announcementText) {
          const text = docSnap.data().announcementText;
          setAnnouncementText(text);

          // Cache the result
          localStorage.setItem('announcementCache', JSON.stringify({
            text,
            timestamp: Date.now()
          }));
        }
      } catch (error) {
        console.error('Error loading announcement:', error);
        // Keep default text on error
      }
    };

    loadAnnouncementText();
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const heightValue = open ? '2.5rem' : '0px';
    root.style.setProperty('--announcement-height', heightValue);

    return () => {
      root.style.removeProperty('--announcement-height');
    };
  }, [open]);

  if (!open) return null;
  return (
    <div className="relative top-0 left-0 right-0 z-[200] bg-accent text-charcoal text-xs sm:text-sm h-10 flex items-center justify-center px-4 font-medium uppercase tracking-[0.3em]">
      <div className="overflow-hidden flex-1">
        <p className="whitespace-nowrap animate-ticker inline-block">
          {announcementText} &nbsp;&nbsp;&nbsp;&nbsp; {announcementText} &nbsp;&nbsp;&nbsp;&nbsp; {announcementText}
        </p>
      </div>
      <button
        aria-label="Dismiss announcement"
        className="ml-4 text-base leading-none text-charcoal/70 hover:text-charcoal flex-shrink-0"
        onClick={() => setOpen(false)}
      >
        &times;
      </button>
    </div>
  );
};

export default AnnouncementBar;
